import React, { useMemo, useEffect, useCallback, useRef } from "react";
import moment from "moment";
import * as Hygeian from "../../constants/hygeian";
import { Dialog } from "@progress/kendo-react-dialogs";
import { taskTypeTemplates } from "../../constants/taskTypeTemplates";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { Button } from '@progress/kendo-react-buttons';
import { Checkbox, Input } from "@progress/kendo-react-inputs";
import { MultiColumnComboBox } from "@progress/kendo-react-dropdowns";
import { Label } from "@progress/kendo-react-labels";
import { connect } from "react-redux";
import { filterBy } from "@progress/kendo-data-query";
import { getById as getChecklistTaskTemplate } from "../../redux/actions/checklistTaskTemplateActions";
import Waste from "./waste";
import SpotCheck from "./spotcheck";
import CLCheckBox from "./clcheckbox";
import CLNumeric from "./clnumeric";
import CLInput from "./clinput";
import { getLocationDetails } from "../../redux/actions/locationActions";
import { get as getChecklistTemplate } from "../../redux/actions/checklistTemplateActions";
import {
  insert as insertUser,
  update as updateUser,
  remove as removeUser,
} from "../../redux/actions/checklistUserActions";
import { update, insert, remove } from "../../redux/actions/checklistActions";
import { DateTimePicker } from "@progress/kendo-react-dateinputs";
import UserSelection from "../components/UserSelection";
import { getManagedUserBySiteIdList } from "../../redux/actions/authActions";
import MultiSelectCell from "../checklistManagement/checklist/groupMultiSelect";
const hasValue = (value) => (value ? "" : "The value must not be empty");

const columns = [
  {
    field: "checklistTemplate.name",
    header: "Name",
    width: "250px",
  },
  {
    field: "enterprise.name1",
    header: "Enterprise",
    width: "250px",
  },
];

const locationColumns = [
  {
    field: "location.loc",
    header: "Location",
    width: "250px",
  },
  {
    field: "site.siteName",
    header: "Site",
    width: "250px",
  },
  {
    field: "enterprise.name1",
    header: "Enterprise",
    width: "250px",
  },
];

class Checklist extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      saving: false,
      loading: false,
      filter: null,
      option: true,
      isTaskSelected: true,
      isOptionToggle: false,
      showUsers: false,
      selectedUsers: null,
      siteId: null,
      dataItem: null,
      speechTest: null,
      showGroup: true,
      showSpotCheck: false,
      taskValues: [],
      isCompleted: false,
    };
  }

  hideousRenderHack = null;

  mounted = false;

  componentDidMount() {
    this.mounted = true;

    this.hideousRenderHack = setInterval(() => {
      this.setState((prevState) => {
        return {
          hideousTicks: prevState.hideousTicks + 1
        };
      });
    }, 1000);
    this.setState({ dataItem: this.props.item });
    this.props.getLocationDetails();
    this.props.getChecklistTemplate();
    if (this.props.isEditMode) {
      let selectedUsers = [];
      let taskValues = [];
      // FIXME: if opening a checklist by link
      // open the first task and change the
      // switch, if it is a spotcheck task
      this.props.item?.users?.forEach((user) => {
        selectedUsers = [...selectedUsers, user.user];
      });
      this.props.item?.checklistTask.forEach((task) => {
        let id = task.checklistTask.taskTypeTemplateId;
        let tmp = taskTypeTemplates.filter((item) => {
          return item.id === id;
        });
        if (tmp.length === 1) {
          taskValues.push({
            templateName: tmp[0].name,
            sequence: task.checklistTask.sequence,
            jsonValue: task.checklistTask.jsonValue
          });
        }
      });
      this.setState({
        isCompleted: this.props.item?.checklist.isCompleted,
        siteId: this.props.item?.site.siteid1,
        selectedUsers: selectedUsers,
        taskValues: taskValues,
      });
    } else {
      this.setState({
        isCompleted: false,
        siteId: {},
        selectedUsers: [],
        taskValues: [],
      });
    }
  }

  componentWillUnmount() {
    this.mounted = false;
    clearInterval(this.hideousRenderHack);
    this.hideousRenderHack = null;
  }

  handleSubmit = async (event) => {
    return await wrapWithBusyFlag(this, 'saving', async () => {
      await this.handleSubmitImpl(event);
    });
  }

  handleSubmitImpl = async (event) => {
    const form = event.currentTarget;
    let date = new Date();
    let strDate = moment(date).format("YYYY-MM-DDTHH:mm:ss");
    let item = {
      checklistTemplate: {},
      location: event.location.location,
      comment: event.comment ? event.comment : null,
      dateScheduled:
        event.dateScheduled ? event.dateScheduled : date,
      checklistTaskTemplates: [],
      users: this.state.selectedUsers
        ? this.state.selectedUsers
        : this.props.users,
      group: this.state.dataItem?.group,
    };

    if (this.props.isEditMode) {
      let checklistTaskTemplates = [];
      event.task.forEach((task) => {
        task.checklistTask.value =
          event[task.checklistTask.id] != undefined
            ? event[task.checklistTask.id].toString()
            : task.checklistTask.value;

        checklistTaskTemplates = [
          ...checklistTaskTemplates,
          task.checklistTask,
        ];
      });
      this.state.taskValues.forEach((taskItem) => {
        checklistTaskTemplates.forEach((tempItem) => {
          if (tempItem.sequence == taskItem.sequence) {
            if (taskItem.templateName == "spotcheck") {
              tempItem.jsonValue = JSON.stringify(taskItem.jsonValue);
              tempItem.dateCompleted = taskItem.dateCompleted;
            }
            else if (taskItem.templateName == "waste") {
              tempItem.value = JSON.stringify(taskItem.value);
            }
            else {
              tempItem.value = taskItem.value;
            }
          }
        });
      });
      item.checklistTaskTemplates = checklistTaskTemplates;
      item.dateCompleted = checklistTaskTemplates.some(item => item.hasOwnProperty('jsonValue')) ? strDate : null;
      // item.isCompleted = checklistTaskTemplates.some(item => item.hasOwnProperty('jsonValue')) ? true : false;

      item.isCompleted = item.dateCompleted ? true : false;
      await this.props.update(item);
      await this.props.onUpdate?.(item);
    } else {
      let checklistTaskTemplates = [];
      this.props.checklistTaskTemplates.forEach((i) => {
        i.checklistTaskTemplate.value =
          event[i.checklistTaskTemplate.id] != undefined
            ? event[i.checklistTaskTemplate.id].toString()
            : null;
        checklistTaskTemplates = [
          ...checklistTaskTemplates,
          i.checklistTaskTemplate,
        ];
      });
      this.state.taskValues.forEach((taskItem) => {
        checklistTaskTemplates.forEach((tempItem) => {
          if (tempItem.sequence == taskItem.sequence) {
            if (taskItem.templateName == "spotcheck") {
              tempItem.jsonValue = JSON.stringify(taskItem.jsonValue);
              tempItem.dateCompleted = taskItem.dateCompleted;
            }
            else if (taskItem.templateName == "waste") {
              tempItem.value = JSON.stringify(taskItem.value);
            }
            else {
              tempItem.value = taskItem.value;
            }
          }
          return tempItem
        });
      });
      item.checklistTaskTemplates = checklistTaskTemplates;
      item.checklistTemplate = event.checklistTemplate.checklistTemplate;
      item.dateCompleted = checklistTaskTemplates.some(item => item.hasOwnProperty('jsonValue')) ? strDate : null;
      // item.isCompleted = checklistTaskTemplates.some(item => item.hasOwnProperty('jsonValue')) ? true : false;

      item.isCompleted = item.dateCompleted ? true : false;
      // console.log("item => ", item);
      await this.props.insert(item);
      await this.props.onInsert?.(item);
    }
    await this.props.handleSubmit();    
  };

  deleteChecklist = async (event) => {
    await this.props.remove(this.props.item);
    await this.props.onDelete?.(this.props.item);
    await this.props.handleSubmit();
  };

  editSpotCheck = (event) => {
    this.setState({
      showSpotCheck: true,
    });
  };

  onCheckBoxChange = (event) => {
    this.saveInfo(event);
  };

  saveInfo = (event) => {
    let temp = this.state.taskValues;
    if (temp.length == 0) {
      temp.push(event);
    } else {
      let chk = temp.filter((item) => {
        return item.sequence == event.sequence;
      });
      if (chk.length == 0) {
        temp.push(event);
      } else if (chk.length == 1) {
        temp.map((item) => {
          if (item.sequence == event.sequence) {
            item.value = event.value;
          }
          return item;
        });
      } else {
        let max = chk.length - 1;
        for (var i = max; i > 0; i--) {
          temp.pop(chk[9]);
        }
      }
    }
    this.setState({
      taskValues: temp,
    });
  };

  onNumericChange = (event) => {
    this.saveInfo(event);
  };

  onInputChange = (event) => {
    this.saveInfo(event);
  };

  onSpotCheckChange = (event) => {
    // console.log(event)
    let temp = this.state.taskValues;
    if (temp.length == 0) {
      temp.push(event);
    } else {
      let ck = temp.filter((item) => item.sequence == event.sequence);
      if (ck.length == 0) {
        temp.push(event);
      } else {
        for (var i = 0; i < temp.length; i++) {
          if (temp[i].sequence == ck[0].sequence) {
            temp[i].templateName = event.templateName;
            temp[i].jsonValue = event.jsonValue;
            temp[i].dateCompleted = event.dateCompleted;
            break;
          }
        }
      }
    }
    this.setState({
      taskValues: temp,
    });
  };

  onWasteChange = (event) => {
    let temp = this.state.taskValues;
    if (temp.length == 0) {
      temp.push(event);
    } else {
      let ck = temp.filter((item) => item.sequence == event.sequence);
      if (ck.length == 0) {
        temp.push(event);
      } else {
        for (var i = 0; i < temp.length; i++) {
          if (temp[i].sequence == ck[0].sequence) {
            temp[i].templateName = event.templateName;
            temp[i].value = event.value;
            break;
          }
        }
      }
    }
    setTimeout(() => {
      this.setState({
        taskValues: temp,
      });
    }, 1000);
  };

  onTaskChange = (event) => {
    if (event.value) {
      this.setState({ showGroup: false });
      this.props.getChecklistTaskTemplate(event.value.checklistTemplate.id);
      this.setState({ dataItem: event.value });
      this.setState({ showGroup: true });
    }
  };

  onLocationChange = (event) => {
    this.setState({ siteId: event.value.site.siteid1 });
    if (this.props.isNew) {
      this.props.getManagedUserBySiteIdList(event.value.site.siteid1);
    }
  };

  handleFilterChange = (event) => {
    if (event) {
      this.setState({ filter: event.filter });
    }
  };

  cancelEdit = (event) => {
    this.setState({ isTaskSelected: false });
    this.props.cancelEdit(event);
  };

  optionsEvent = (event) => {
    this.setState({ option: !this.state.option });
  };

  showUsers = () => {
    this.setState({
      showUsers: !this.state.showUsers,
      selectedUsers:
        this.state.selectedUsers == null
          ? this.props.users
          : this.state.selectedUsers,
    });
  };

  getHeight = () => {
    const body = document.body;
    const html = document.documentElement;
    const height = Math.max(body.scrollHeight, body.offsetHeight,
      html.clientHeight, html.scrollHeight, html.offsetHeight);
    return height;
  }

  getWidth = () => {
    const body = document.body;
    const html = document.documentElement;
    const width = Math.max(body.scrollWidth, body.offsetWidth,
      html.clientWidth, html.scrollWidth, html.offsetWidth);
    return width;
  }

  onCompleteChange = (event) => {
    this.setState({
      isCompleted: event.target.value,
    });
  };

  updateSelectedUsers = (event) => {
    let selectedUsers = Object.assign([], this.state.selectedUsers);
    let removedUser = null;
    let addedUser = null;
    selectedUsers.forEach((user) => {
      if (!event.some((e) => e.email === user.email)) removedUser = user;
    });
    event.forEach((user) => {
      if (!selectedUsers.some((e) => e.email === user.email)) addedUser = user;
    });
    if (this.props.isEditMode) {
      if (addedUser) {
        let checklistUserSearch = {
          user: addedUser,
          checklistUser: { checklistId: this.props.item?.checklist.id },
        };
        this.props.insertUser(checklistUserSearch);
      }
      if (removedUser) {
        let userChecklist = this.props.checklist.find(
          (check) => check.checklist.id == this.props.item?.checklist.id
        );
        let user = userChecklist.users.find(
          (user) => user.user.email == removedUser.email
        );
        this.props.removeUser(user);
      }
    }
    this.setState({ selectedUsers: event });
  };

  onGroupChange = (event) => {
    let dataItem = this.state.dataItem;
    dataItem["group"] = event.value;
  };

  render() {
    console.log('Checklist props: ', this.props, 'state:', this.state);
    // if (!this.props.item)
    //   return null;
    let declaration = null;
    let filter = this.state.filter;
    if (this.props.isEditMode) {
      declaration = (
        <Field
          size={"large"}
          name={"dateCompleted"}
          component={Checkbox}
          defaultValue={this.props.item?.checklist.isCompleted}
          value={this.state.isCompleted}
          onChange={this.onCompleteChange}
          disabled={true}
        />
      );
    } else {
      declaration = (
        <Field
          size={"large"}
          name={"dateCompleted"}
          component={Checkbox}
          defaultValue={this.state.isCompleted}
          value={this.state.isCompleted}
          onChange={this.onCompleteChange}
          disabled={true}
        />
      );
    }

    let checklistTemplates = [];
    if (this.props.checklistTemplates) {
      checklistTemplates = this.props.checklistTemplates;
    }
    let checklistTask = [];
    let checklistTaskTemplates = [];
    if (this.props.item == null) {
      if (this.props.checklistTaskTemplates) {
        checklistTaskTemplates = []
          .concat(this.props.checklistTaskTemplates)
          .sort((a, b) =>
            a.checklistTaskTemplate.sequence > b.checklistTaskTemplate.sequence
              ? 1
              : -1
          );
      }
    } else {
      checklistTask = []
        .concat(this.props.item?.checklistTask)
        .sort((a, b) =>
          a.checklistTask.sequence > b.checklistTask.sequence ? 1 : -1
        );
    }

    let location = [];
    if (this.props.location) {
      location = this.props.location;
    }
    let initialData = null;
    if (this.props.isEditMode) {
      initialData = {
        location: {
          location: this.props.item?.location,
          site: this.props.item?.location,
          enterprise: this.props.item?.enterprise,
        },
        task: this.props.item?.checklistTask,
        comment: this.props.item?.checklist.comment,
      };
    } else {
      initialData = {
        location: this.props.lastLocation
      }
    }

    let defaultValue = new Date();
    if (this.props.isEditMode) {
      defaultValue = new Date(this.props.item?.checklist.dateScheduled);
    }

    let docWidth = this.getWidth();
    let docHeight = this.getHeight();
    let maxHeight = docHeight - (docHeight * 0.5);
    let maxHeight2 = docHeight - (docHeight * 0.35);
    let minHeight = docHeight - (docHeight * 0.65);
    let minHeight2 = docHeight - (docHeight * 0.65);
    let maxWidth = docWidth - (docWidth * 0.65);
    let minWidth = docWidth - (docWidth * 0.7);
    const hash = window.location.search?.includes('openchecklist=');
    return (
      <div className={"pg-checkbox"}>
        <Dialog
          title={
            !this.props.isEditMode && !this.props.isDeleteMode
              ? "Create New Checklist"
              : this.props.item?.checklist?.name
                ? this.props.item?.checklist.name
                : "Checklist"
          }
          onClose={this.props.cancelEdit}
        >          
          <Form
            onSubmit={
              !this.props.isDeleteMode
                ? this.handleSubmit
                : this.deleteChecklist
            }
            initialValues={initialData}
            render={(formRenderProps) => (
              <FormElement
                style={{
                  minWidth: minWidth,
                  minHeight: minHeight,
                  maxWidth: maxWidth,
                  maxHeight: maxHeight
                }}
              >
                {this.state.showUsers ? (
                  <UserSelection
                    isEnterpriseSearch={false}
                    updateSelectedUsers={this.updateSelectedUsers}
                    selectedUsers={this.state.selectedUsers}
                    siteId={this.state.siteId}
                    isSelectAllUsers={true}
                  />
                ) : (
                  <fieldset
                    className={"k-form-fieldset"}
                    style={{
                      overflowY: "auto",
                      maxHeight: maxHeight2,
                      minHeight: minHeight2
                    }}
                  >
                    <div className="mb-3">
                      <Field
                        name={"dateScheduled"}
                        component={DateTimePicker}
                        format={"dd/MM/yyyy"}
                        label={"Scheduled Date"}
                        defaultValue={defaultValue}
                        disabled={
                          this.props.isDeleteMode || this.props.isEditMode
                        }
                      />
                    </div>
                    {!this.props.isEditMode && (
                      <div className="mb-3">
                        <Field
                          name={"checklistTemplate"}
                          component={MultiColumnComboBox}
                          data={
                            filter
                              ? filterBy(checklistTemplates, filter)
                              : checklistTemplates
                          }
                          textField={"checklistTemplate.name"}
                          label={"Checklist"}
                          columns={columns}
                          onChange={this.onTaskChange}
                          filterable={true}
                          onFilterChange={this.handleFilterChange}
                          validator={hasValue}
                          disabled={this.props.isDeleteMode}
                        />
                      </div>
                    )}
                    <div className="mb-3">
                      <div>{location.loc}</div>
                      <Field
                        name={"location"}
                        component={MultiColumnComboBox}
                        data={
                          filter
                            ? filterBy(location, filter)
                            : location
                        }
                        textField={"location.loc"}
                        label={"Location"}
                        columns={locationColumns}
                        onChange={this.onLocationChange}
                        filterable={true}
                        onFilterChange={this.handleFilterChange}
                        validator={hasValue}
                        disabled={this.props.isDeleteMode}
                      />
                    </div>
                    <div className="mb-3">
                      <table border={0} cellPadding={0} cellSpacing={0}>
                        <tbody>
                          <tr>
                            <Field
                              label={"Group"}
                              name={"Group"}
                              component={MultiSelectCell}
                              validationmessage={"Please select a Checklist"}
                              disabled={
                                this.props.isDeleteMode ||
                                this.state.dataItem == null
                              }
                              inEdit={true}
                              dataItem={this.state.dataItem}
                              data={this.props.group}
                              field={"group"}
                              onChange={this.onGroupChange}
                            />
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    {this.state.option && (
                      <div className="mb-3">
                        <div className="k-grid-container">
                          <div>
                            <table border={"0"} className={"k-grid-table"}>
                              <thead>
                                <tr>
                                  <th>Task</th>
                                  <th>Action</th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody>
                                {checklistTaskTemplates.map((task, taskIndex) => {
                                  return (
                                    <React.Fragment key={task.checklistTaskTemplate.id}>
                                      {task.taskTypeTemplate.name ===
                                        "checkbox" && (
                                          <CLCheckBox
                                            task={task}
                                            sequence={
                                              task.checklistTaskTemplate.sequence
                                            }
                                            templateName={
                                              task.taskTypeTemplate.name
                                            }
                                            isEditMode={this.props.isEditMode}
                                            isDeleteMode={this.props.isDeleteMode}
                                            canUpdate={this.props.canUpdate}
                                            onChange={this.onCheckBoxChange}
                                          />
                                        )}
                                      {task.taskTypeTemplate.name ===
                                        "numeric" && (
                                          <CLNumeric
                                            task={task}
                                            sequence={
                                              task.checklistTaskTemplate.sequence
                                            }
                                            templateName={
                                              task.taskTypeTemplate.name
                                            }
                                            isEditMode={this.props.isEditMode}
                                            isDeleteMode={this.props.isDeleteMode}
                                            onChange={this.onNumericChange}
                                            canUpdate={this.props.canUpdate}
                                          />
                                        )}
                                      {task.taskTypeTemplate.name ===
                                        "input" && (
                                          <CLInput
                                            task={task}
                                            sequence={
                                              task.checklistTaskTemplate.sequence
                                            }
                                            templateName={
                                              task.taskTypeTemplate.name
                                            }
                                            isEditMode={this.props.isEditMode}
                                            isDeleteMode={this.props.isDeleteMode}
                                            onChange={this.onInputChange}
                                          />
                                        )}
                                      {task.taskTypeTemplate.name ===
                                        "spotcheck" && (
                                          <SpotCheck
                                            task={task}
                                            sequence={
                                              task.checklistTaskTemplate.sequence
                                            }
                                            templateName={
                                              task.taskTypeTemplate.name
                                            }
                                            isEditMode={this.props.isEditMode}
                                            isDeleteMode={this.props.isDeleteMode}
                                            initiallyOn={taskIndex === 0 && hash}
                                            onChange={this.onSpotCheckChange}
                                          />
                                        )}
                                      {task.taskTypeTemplate.name ===
                                        "waste" && (
                                          <Waste
                                            task={task}
                                            sequence={
                                              task.checklistTaskTemplate.sequence
                                            }
                                            templateName={
                                              task.taskTypeTemplate.name
                                            }
                                            isEditMode={this.props.isEditMode}
                                            isDeleteMode={this.props.isDeleteMode}
                                            onChange={this.onWasteChange}
                                          />
                                        )}
                                    </React.Fragment>
                                  );
                                })}
                                {checklistTask.map((task, taskIndex) => {
                                  const reactKey = `${task.checklistTask.checklistId}:${task.checklistTask.id}`;
                                  return (
                                    <React.Fragment key={reactKey}>
                                      {task.taskTypeTemplate.name ===
                                        "checkbox" && (
                                          <CLCheckBox
                                            task={task}
                                            sequence={task.checklistTask.sequence}
                                            templateName={
                                              task.taskTypeTemplate.name
                                            }
                                            isEditMode={this.props.isEditMode}
                                            isDeleteMode={this.props.isDeleteMode}
                                            canUpdate={this.props.canUpdate}
                                            onChange={this.onCheckBoxChange}
                                          />
                                        )}
                                      {task.taskTypeTemplate.name ===
                                        "numeric" && (
                                          <CLNumeric
                                            task={task}
                                            sequence={task.checklistTask.sequence}
                                            templateName={
                                              task.taskTypeTemplate.name
                                            }
                                            isEditMode={this.props.isEditMode}
                                            isDeleteMode={this.props.isDeleteMode}
                                            onChange={this.onNumericChange}
                                            canUpdate={this.props.canUpdate}
                                          />
                                        )}
                                      {task.taskTypeTemplate.name ===
                                        "input" && (
                                          <CLInput
                                            task={task}
                                            sequence={task.checklistTask.sequence}
                                            templateName={
                                              task.taskTypeTemplate.name
                                            }
                                            isEditMode={this.props.isEditMode}
                                            isDeleteMode={this.props.isDeleteMode}
                                            onChange={this.onInputChange}
                                          />
                                        )}
                                      {task.taskTypeTemplate.name ===
                                        "spotcheck" && (
                                          <SpotCheck
                                            task={task}
                                            sequence={task.checklistTask.sequence}
                                            templateName={
                                              task.taskTypeTemplate.name
                                            }
                                            isEditMode={this.props.isEditMode}
                                            isDeleteMode={this.props.isDeleteMode}
                                            initiallyOn={taskIndex === 0 && hash}
                                            onChange={this.onSpotCheckChange}
                                          />
                                        )}
                                      {task.taskTypeTemplate.name ===
                                        "waste" && (
                                          <Waste
                                            task={task}
                                            sequence={task.checklistTask.sequence}
                                            templateName={
                                              task.taskTypeTemplate.name
                                            }
                                            isEditMode={this.props.isEditMode}
                                            isDeleteMode={this.props.isDeleteMode}
                                            onChange={this.onWasteChange}
                                          />
                                        )}
                                    </React.Fragment>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        </div>
                        {false && this.props.isHygeianAdmin && <>
                          <SpeechInput
                            onFinalResult={(transcript) => {
                              this.setState((prevState) => ({
                                speechTest: transcript
                              }));
                            }}
                            onError={(err) => {
                              this.setState({
                                speechTest: `Error : ${err.error} ${err.message}`
                              });
                            }}
                            onInterimResults={(transcript) => {
                              this.setState((prevState) => ({
                                speechTest: prevState.speechTest + transcript
                              }));
                            }}
                            children={'🎤'}
                          />
                          <input value={this.state.speechTest || ''}
                            onChange={(event) => {
                              this.setState({
                                speechTest: event.target.value
                              });
                            }}/>
                          <button type="button" children='???' onClick={(event) => {
                            event.preventDefault();
                            event.stopPropagation();
                            this.setState({
                              speechTest: '???'
                            });
                          }}/>
                        </>}
                        <Field
                          name={"comment"}
                          component={Input}
                          label={"Comment"}
                          disabled={this.props.isDeleteMode}
                        />
                        <div className={"checklistBoxes"}>
                          <Label style={{ fontSize: "25px" }}>
                            Complete
                          </Label>
                          <div style={{ margin: 7 }}>{declaration}</div>
                        </div>
                      </div>
                    )}
                  </fieldset>
                )}
                <div
                  className="k-form-buttons"
                  style={{
                    paddingBottom: "20",
                    position: "relative",
                    display: "inline",
                  }}
                >
                  <div
                    style={{
                      float: "left",
                    }}
                  >
                    {!this.props.isDeleteMode ? (
                      <button
                        type={"submit"}
                        className="k-button k-primary"
                        disabled={
                          !(formRenderProps.allowSubmit || this.props.canCreate)
                        }
                      >
                        Save
                      </button>
                    ) : (
                      <button
                        disabled={
                          !(formRenderProps.allowSubmit || this.props.canDelete)
                        }
                        type="button"
                        className="k-button k-primary"
                        onClick={this.deleteChecklist}
                      >
                        Delete
                      </button>
                    )}

                    <button
                      type={"submit"}
                      className="k-button"
                      style={{
                        marginLeft: "10px",
                      }}
                      onClick={this.cancelEdit}
                    >
                      Cancel
                    </button>
                  </div>
                  <div
                    style={{
                      float: "right",
                    }}
                  >
                    <div
                      className="k-button k-primary"
                      onClick={this.showUsers}
                      disabled={!this.state.selectedUsers && !this.state.siteId}
                    >
                      {this.state.showUsers ? (
                        <div>Show Checklist</div>
                      ) : (
                        <div>Show Users</div>
                      )}
                    </div>
                  </div>
                </div>
              </FormElement>
            )}
          />

          {(this.props.pending ||
            this.props.checklistTemplatesPending ||
            this.props.usersPending ||
            this.props.checklistPending ||
            this.state.saving ||
            this.props.locationPending) && (
              <div className="k-loading-mask">
                <span className="k-loading-text">Loading</span>
                <div className="k-loading-image"></div>
                <div className="k-loading-color"></div>
              </div>
            )}
          {/* {this.state.saving && <div 
            style={{
              position: 'absolute',
              left: 0, top: 0,
              right: 0, bottom: 0,
              display: 'inline-block',
              cursor: 'wait',
              background: 'rgba(255, 255, 255, 0.7)'
            }}
            />
          } */}
        </Dialog>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    checklistTaskTemplates:
      state.checklistTaskTemplateReducer.checklistTaskTemplates,
    pending: state.checklistTaskTemplateReducer.pending,
    checklistTemplates: state.checklistTemplateReducer.checklistTemplates,
    location: state.locationReducer.location,
    checklistTemplatesPending: state.checklistTemplateReducer.pending,
    locationPending: state.locationReducer.pending,
    users: state.authReducer.users,
    usersPending: state.authReducer.pending,
    checklist: state.checklistReducer.checklist,
    checklistPending: state.checklistReducer.pending,
    group: state.groupReducer.group,
    isHygeianAdmin: state.authReducer.user.profile.scopeid === Hygeian.ScopeId
  };
};

const mapDispatchToProps = {
  getChecklistTaskTemplate,
  getLocationDetails,
  getChecklistTemplate,
  insertUser,
  updateUser,
  removeUser,
  getManagedUserBySiteIdList,
  update,
  insert,
  remove,
};

//export default Instrument;
export default connect(mapStateToProps, mapDispatchToProps)(Checklist);

export const SpeechInput = (props) => {
  const {
    onInterimResults,
    onFinalResult,
    onError,
    onEnd
  } = props;

  const SpeechRecognition = useMemo(() => {
    return window.SpeechRecognition || window.webkitSpeechRecognition;
  }, []);

  const recognition = useRef(null);

  useEffect(() => {
    const r = new SpeechRecognition();
    recognition.current = r;
    
    r.continuous = true;
    r.interimResults = true;
    r.lang = 'en-US';

    const result = (event) => {
      let transcript = '';
      // Iterate from the resultIndex to the end of results
      for (let i = event.resultIndex; i < event.results.length; i++) {
        // Append the transcript from the first alternative
        transcript += event.results[i][0].transcript;
        // Optionally, check if the result is final and act accordingly:
        if (event.results[i].isFinal) {
          console.log('Final result:', transcript);
          onFinalResult?.(transcript);
        } else {
          console.log('Interim result:', transcript);
          onInterimResults?.(transcript);
        }
      }
      // You can update state or perform additional actions with the transcript here.
    };

    const error = (event) => {
      console.error('Speech recognition error detected:', event);
      onError?.(event);
    };

    const end = (event) => {
      console.log('Speech recognition ended');
      if (onEnd?.() === true)
        recognition.start();
    };

    r.addEventListener('result', result);
    r.addEventListener('error', error);
    r.addEventListener('end', end);
    //r.start();

    return () => {
      r.stop();
      r.removeEventListener('end', end);
      r.removeEventListener('error', error);
      r.removeEventListener('result', result);
    };
  }, [SpeechRecognition, onEnd, onError, onFinalResult, onInterimResults]);

  const handleStart = useCallback((event) => {
    event.preventDefault();
    event.stopPropagation();
    recognition.current?.start();
  }, []);

  return <Button type="button" 
    onClick={handleStart} 
    children={props.children}/>;
}

export async function  wrapWithBusyFlag(component, prop, callback) {
  component.setState({
    [prop]: true
  });
  try {
    return await callback();
  } finally {
    if (component.mounted !== false) {
      component.setState({
        [prop]: false
      });
    }
  }
}
